import { render, staticRenderFns } from "./Offline.vue?vue&type=template&id=13512368&scoped=true"
import script from "./Offline.vue?vue&type=script&lang=js"
export * from "./Offline.vue?vue&type=script&lang=js"
import style0 from "./Offline.vue?vue&type=style&index=0&id=13512368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13512368",
  null
  
)

export default component.exports